module.exports = {
    makes: [
        {
            name: 'ACURA',
        },
        {
            name: 'HONDA',
        },
    ],
};
